import { makeStyles, tokens } from '@fluentui/react-components';

export const useStyles = makeStyles({
  // Full-bleed surface — the header + body manage their own spacing, so
  // strip DialogSurface's default padding and let the body host a tall
  // iframe edge-to-edge.
  surface: {
    width: '90vw',
    maxWidth: '90vw',
    height: '90vh',
    maxHeight: '90vh',
    paddingTop: '0',
    paddingRight: '0',
    paddingBottom: '0',
    paddingLeft: '0',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },

  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: tokens.spacingHorizontalM,
    paddingTop: tokens.spacingVerticalM,
    paddingRight: tokens.spacingHorizontalM,
    paddingBottom: tokens.spacingVerticalM,
    paddingLeft: tokens.spacingHorizontalXL,
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
    borderBottomColor: tokens.colorNeutralStroke2,
    flexShrink: '0',
  },

  titleBlock: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
    minWidth: '0',
  },

  title: {
    fontSize: tokens.fontSizeBase500,
    fontWeight: tokens.fontWeightSemibold,
    lineHeight: tokens.lineHeightBase500,
    color: tokens.colorNeutralForeground1,
  },

  subtitle: {
    fontSize: tokens.fontSizeBase200,
    fontFamily: tokens.fontFamilyMonospace,
    color: tokens.colorNeutralForeground3,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },

  body: {
    flex: '1',
    minHeight: '0',
    display: 'flex',
    overflow: 'hidden',
  },

  // The scorecard report is server-rendered HTML — fill the body.
  iframe: {
    width: '100%',
    height: '100%',
    borderTopStyle: 'none',
    borderRightStyle: 'none',
    borderBottomStyle: 'none',
    borderLeftStyle: 'none',
    backgroundColor: tokens.colorNeutralBackground1,
  },

  centered: {
    flex: '1',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  error: {
    color: tokens.colorPaletteRedForeground1,
    paddingTop: tokens.spacingVerticalL,
    paddingLeft: tokens.spacingHorizontalXL,
  },
});
